import { ROLES, type RoleStrategy } from "@pharmupp/p3-front-commons"
import { MyPharmacyEnum } from "./MyPharmacy.schema"

const adhRoleConf = {
  [MyPharmacyEnum.NAME]: { disabled: true },
}

export const formRoleConf: RoleStrategy<
  Partial<Record<MyPharmacyEnum, { disabled: boolean }>>
> = {
  [ROLES.ADHERENT_HOLDER]: adhRoleConf,
  [ROLES.ADHERENT_TEAM]: adhRoleConf,
  [ROLES.ADMIN]: {},
}
